import { I621Form } from 'legacy/lut/features/partner360/configuration'
import { IMarketSector } from 'legacy/lut/features/partner360/marketInfo'

export const mapMarketSectorTo621 = (data: Partial<IMarketSector>): Partial<I621Form> => {
  const mapped: Partial<I621Form> = {
    MarketSectorShowPercent:
      data.isPercentMode === undefined ? undefined : data.isPercentMode ? 1 : 0,
    MarketSectorPublic: data.public,
    MarketSectorSMBManaged: data.smbManaged,
    MarketSectorSMBUnmanaged: data.smbUnmanaged,
    MarketSectorCorporate: data.corporate,
    MarketSectorSMB: data.smb,
    MarketSectorEnterprise: data.enterprise,
    MarketSectorMiddleMarket: data.middleMarket,
  }

  for (const key in mapped) {
    if (mapped[key] === undefined) {
      delete mapped[key]
    }
  }

  return mapped
}
